import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { ChevronDoubleRightIcon } from '@heroicons/react/24/outline';
import { Button } from '@nextui-org/react';
import useSWR from 'swr';
import { BASE_URL, getFetcherPublic } from '../../services/api';
import ArticleCard from './ArticleCard';
import { useNavigate } from 'react-router-dom';

export default function SectionEvent() {
    const navigate = useNavigate();

    const { data: dataArticle, isLoading: loadingArticle } = useSWR(
        `/api/content/search-articles?page=1&limit=10&sortBy=createdAt`,
        getFetcherPublic
    );

    return (
        <div className="bg-[#00453F] px-5 md:px-10 lg:px-20 py-10 mt-10">
            <div className="w-full flex flex-col lg:flex-row gap-5">
                {/* Text Section */}
                <div className="w-full lg:w-1/3 flex flex-col gap-4 mb-6 md:mb-0">
                    <p className="text-white text-2xl lg:text-3xl text-center lg:text-start">Artikel Pilihan</p>
                    <p className="text-white text-base lg:text-lg text-center lg:text-start">
                        Dapatkan wawasan mendalam dan informasi terbaru mengenai berbagai topik dari Direktorat
                        Pengelolaan B3
                    </p>
                    <div className='flex justify-center lg:justify-start'>
                        <Button className="bg-[#00000059] text-white" onClick={() => navigate('/artikel')}>
                            Simak semua artikel <ChevronDoubleRightIcon className="size-4" />
                        </Button>
                    </div>
                </div>

                {/* Swiper Section */}
                <div className="w-full lg:w-2/3">
                    <Swiper
                        breakpoints={{
                            640: {
                                slidesPerView: 1.1
                            },
                            768: {
                                slidesPerView: 2.1,
                            },
                            1024: {
                                slidesPerView: 2.2,
                            },
                            1281: {
                                slidesPerView: 2.5,
                            },
                            1536: {
                                slidesPerView: 3,
                            },
                        }}
                        centeredSlides={false}
                        loop={true}
                        spaceBetween={15}
                        autoplay={{
                            delay: 3000, // Waktu delay dalam milidetik
                            disableOnInteraction: false, // Tetap autoplay meskipun user berinteraksi
                        }}
                    >
                        {!loadingArticle &&
                            dataArticle?.data?.map((data, index) => (
                                <SwiperSlide key={index}>
                                    <ArticleCard data={data} />
                                </SwiperSlide>
                            ))}
                    </Swiper>
                </div>
            </div>
        </div>
    );
}
